Customer.Views ||= {}
Customer.Views.Insights ||= {}

class Customer.Views.Insights.ActivityDrillDownView extends Backbone.View
  el: '#activity-results'

  events:
    'click .drill-down': '_openActivityDrillDownWindow'

  initialize: (@options = {}) ->
    @_processSelectedFilters()

  remove: ->
    @$el.off()
    @stopListening()
    @

  _processSelectedFilters: ->
    @selectedFilters = {}
    @selectedFilters[field.name] = field.value for field in @options when field.name not in @_arrayFields()
    _.each(@_arrayFields(), (field_name) =>
      field_key = field_name.substr(0, field_name.length - 2)
      @selectedFilters["#{field_key}"] = []
      @selectedFilters["#{field_key}"] = (field.value for field in @options when field.name is field_name)
    )
    @_filterCustomAttributes()

  _arrayFields: ->
    [
      'users[]'
      'sub_types[]'
      'user_groups[]'
      'main_tags[]'
      'secondary_tags[]'
      'excluded_tags[]'
      'main_groups[]'
      'secondary_groups[]'
      'excluded_groups[]'
      'tags_custom_attributes[]'
    ]

  _openActivityDrillDownWindow: (event) ->
    event.preventDefault()
    $cell = $(event.currentTarget)
    window.open("/customer/activity/drilldown/#{$cell.data 'drilldown'}?#{@_urlQuery $cell}", '_blank')

  _urlQuery: ($cell) ->
    [
      "account_id=#{@selectedFilters.account_id}"
      "from=#{@selectedFilters.from}"
      "to=#{@selectedFilters.to}"
      "activity_include=#{@selectedFilters.activity_include}"
      "activity_type=#{@selectedFilters.activity_type}"
      @_subtypesForUrlQuery $cell
      @_datesForUrlQuery $cell
      @_timezoneForUrlQuery $cell
      @_usersForUrlQuery $cell
      @_userGroupsForUrlQuery $cell
      @_hasRobotForUrlQuery $cell
      @_tagsForUrlQuery()
      @_groupsForUrlQuery()
      @_customAttributesForUrlQuery()
    ].join('&')

  _datesForUrlQuery: ($cell) ->
    return "date=#{$cell.data('date')}" if $cell.data('date')?
    if $cell.data('startdate')?
      ["start_date=#{$cell.data('startdate')}"
        "end_date=#{$cell.data('enddate')}"].join('&')

  _usersForUrlQuery: ($cell) ->
    @_cellOperator($cell) or @_selectedUsers()

  _subtypesForUrlQuery: ($cell) ->
    @_cellSubtype($cell) or @_selectedSubtypes()

  _userGroupsForUrlQuery: ($cell) ->
    @_cellUserGroup($cell) or @_selectedUserGroups()

  _timezoneForUrlQuery: ($cell) ->
    @_cellTimezone($cell) or @_selectedTimezone()

  _cellUserGroup: ($cell) ->
    "user_groups[]=#{$cell.data('usergroup')}" if $cell.data('usergroup')?

  _cellOperator: ($cell) ->
    "users[]=#{$cell.data('operator')}" if $cell.data('operator')?

  _cellSubtype: ($cell) ->
    "sub_types[]=#{$cell.data('subtype')}" if $cell.data('subtype')?

  _cellTimezone: ($cell) ->
    "timezone=#{encodeURIComponent($cell.data('timezone'))}" if $cell.data('timezone')?

  _selectedUsers: ->
    ("users[]=#{user}" for user in @selectedFilters.users).join('&')

  _selectedUserGroups: ->
    ("user_groups[]=#{user_group}" for user_group in @selectedFilters.user_groups).join('&')

  _selectedSubtypes: ->
    ("sub_types[]=#{sub_type}" for sub_type in @selectedFilters.sub_types).join('&')

  _selectedTimezone: ->
    "timezone=#{encodeURIComponent(@selectedFilters.timezone)}"

  _customAttributesForUrlQuery: ->
    @customAttributes.join('&')

  _hasRobotForUrlQuery: ($cell) ->
    # If report is operator, and no operator is selected, should show only the robot
    # that is why we set the users with id 0
    # If the report is team or general, should always show the robot
    if @selectedFilters.activity_type == 'operator'
      unless $cell.data('operator')?
        "has_robot=#{@selectedFilters.has_robot}&users[]=0"
    else
      "has_robot=#{@selectedFilters.has_robot}"


  _tagsForUrlQuery: ->
    [
      @_tagsLogic()
      @_tagsSelected()
    ].join('&')

  _tagsLogic: ->
    [
      "main_tags_logic=#{@selectedFilters.main_tags_logic}"
      "secondary_tags_logic=#{@selectedFilters.secondary_tags_logic}"
      "excluded_tags_logic=#{@selectedFilters.excluded_tags_logic}"
    ].join('&')

  _tagsSelected: ->
    tag_keys = ['main_tags', 'secondary_tags', 'excluded_tags']
    tags = []
    _.each(tag_keys, (tag_key) =>
      if @selectedFilters[tag_key].length > 0
        tags.push(("#{tag_key}[]=#{tag}" for tag in @selectedFilters[tag_key]).join('&'))
    )
    tags

  _groupsForUrlQuery: ->
    [
      @_groupsLogic()
      @_groupsSelected()
    ].join('&')

  _groupsLogic: ->
    [
      "main_groups_logic=#{@selectedFilters.main_groups_logic}"
      "secondary_groups_logic=#{@selectedFilters.secondary_groups_logic}"
      "excluded_groups_logic=#{@selectedFilters.excluded_groups_logic}"
    ].join('&')

  _groupsSelected: ->
    group_keys = ['main_groups', 'secondary_groups', 'excluded_groups']
    groups = []
    _.each(group_keys, (group_key) =>
      if @selectedFilters[group_key].length > 0
        groups.push(("#{group_key}[]=#{group}" for group in @selectedFilters[group_key]).join('&'))
    )
    groups.join('&')

  _filterCustomAttributes: ->
    @customAttributes = []
    _.each(@options, (option) =>
      if option.name.substr(0, 3) == 'ca_'
        @customAttributes.push("#{option.name}=#{option.value}")
    )
